import React, { FunctionComponent } from 'react';
import macPrivacyLocation from 'assets/images/help/mac-privacy-location.png';
import ImageMagnifier from 'components/imageMagnifier/ImageMagnifier';
import HelpStyles from '../../Help.module.scss';

const Mac: FunctionComponent = () => {
  return (
    <div className={HelpStyles.sharedHelpStyles}>
      <div className={HelpStyles.steps}>
        <div className={HelpStyles.step}>
          <div className={HelpStyles.stepNumber}>1</div>
          <div className={HelpStyles.stepContent}>
            <p className="fontFourteen poppins-regular text-black mb-5">
              Go to <strong>System Settings</strong> → <strong>Privacy & Security</strong> → <strong>Location Services</strong>
            </p>
          </div>
        </div>

        <div className={HelpStyles.step}>
          <div className={HelpStyles.stepNumber}>2</div>
          <div className={HelpStyles.stepContent}>
            <p className="fontFourteen poppins-regular text-black mb-5">
              Ensure <strong>Location Services</strong> is turned on
            </p>
          </div>
        </div>

        <div className={HelpStyles.step}>
          <div className={HelpStyles.stepNumber}>3</div>
          <div className={HelpStyles.stepContent}>
            <p className="fontFourteen poppins-regular text-black mb-5">
              Find <strong>Safari</strong> in the app list and ensure it's enabled
            </p>
          </div>
        </div>

        <div className={HelpStyles.step}>
          <div className={HelpStyles.stepNumber}>4</div>
          <div className={HelpStyles.stepContent}>
            <p className="fontFourteen poppins-regular text-black mb-5">
              For Chrome, look for <strong>Google Chrome</strong> in the list
            </p>
          </div>
        </div>

        <div className={HelpStyles.step}>
          <div className={HelpStyles.stepNumber}>5</div>
          <div className={HelpStyles.stepContent}>
            <p className="fontFourteen poppins-regular text-black mb-5">
              If location services are off, you'll see: "Location is turned off in your Mac system preferences"
            </p>
          </div>
        </div>

        <div className={HelpStyles.step}>
          <div className={HelpStyles.stepNumber}>6</div>
          <div className={HelpStyles.stepContent}>
            <p className="fontFourteen poppins-regular text-black mb-5">
              Click <strong>System settings</strong> to enable location services
            </p>
          </div>
        </div>
      </div>

      <ImageMagnifier 
        src={macPrivacyLocation} 
        alt="Mac Privacy & Security settings showing location permissions" 
        caption="System Settings → Privacy & Security → Location Services"
        className={HelpStyles.screenshot}
      />

      <div className={HelpStyles.tip}>
        <div className={HelpStyles.tipIcon}>💡</div>
        <div className={HelpStyles.tipContent}>
          <p className="fontFourteen poppins-regular text-gray">
            <strong>Tip:</strong> The screenshot shows where to find location services in macOS privacy settings.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Mac;